import React, { useState } from "react";
import Loading from "../../../../../../components/Loading/Loading";
import localeText from "../../../../../../locale";
import ConversionDetailsDialog, { formatConversionExc, formatConversionPoints } from "./ConversionDetailsDialog";
import ExtrapayStatusBadge from "./ExtrapayStatusBadge";
import ExtrapayTable from "./ExtrapayTable";

const getStatus = (row) => {
  if (row.converted) return { labelKey: "extrapayFlowStatusConverted", tone: "success" };
  if (row.open) return { labelKey: "extrapayFlowStatusInProgress", tone: "warning" };
  return { labelKey: "extrapayFlowStatusNotConverted", tone: "neutral" };
};

const PreviousCyclesTable = ({ cycles = [], isLoading }) => {
  const [selected, setSelected] = useState(null);

  if (isLoading) {
    return (
      <div className="flex justify-content-center py-4">
        <Loading classNameIcon="text-4xl" />
      </div>
    );
  }

  const columns = [
    {
      key: "operation",
      header: localeText("extrapayFlowOperation"),
      render: (row) => row.reference,
    },
    {
      key: "cycle",
      header: localeText("extrapayFlowCycle"),
      render: (row) => (row.cycle != null ? row.cycle : localeText("extrapayFlowUnavailable")),
    },
    {
      key: "points",
      header: localeText("extrapayFlowPoints"),
      render: (row) => formatConversionPoints(row.pointsConverted),
    },
    {
      key: "exc",
      header: "EXC",
      render: (row) => formatConversionExc(row.tokensReceived),
    },
    {
      key: "status",
      header: localeText("extrapayFlowSituation"),
      render: (row) => {
        const status = getStatus(row);
        return <ExtrapayStatusBadge labelKey={status.labelKey} tone={status.tone} />;
      },
    },
    {
      key: "details",
      header: "",
      render: (row) => (
        <button
          type="button"
          className="p-0 border-none bg-transparent cursor-pointer"
          style={{ color: "#335CFF" }}
          onClick={() => setSelected(row)}
        >
          {localeText("extrapayFlowViewDetails")}
        </button>
      ),
    },
  ];

  return (
    <>
      <ExtrapayTable
        columns={columns}
        rows={cycles}
        emptyMessage={localeText("extrapayFlowPreviousCyclesEmpty")}
        rowKey={(row) => row.id}
      />
      <ConversionDetailsDialog conversion={selected} onHide={() => setSelected(null)} />
    </>
  );
};

export default PreviousCyclesTable;
